import { render, staticRenderFns } from "./PvReceptionStep.vue?vue&type=template&id=c7b597c2"
import script from "./PvReceptionStep.vue?vue&type=script&lang=js"
export * from "./PvReceptionStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports